import React, { lazy, Suspense } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { routerUtil } from '@utils/config'
import { Loading } from '@com-components/'

const User = lazy(() => import('@pages/dashboard/user/index'))
const Statistic = lazy(() => import('@pages/dashboard/statistic/index'))
export const routerConfig = [
  {
    name: '首页',
    path: '/dashboard/index',
    component: Statistic
  },
  {
    name: '账户设置',
    children: [{ name: '账户基本资料', path: '/dashboard/user', component: User }]
  }
]
const routerMap = routerUtil.sortToRoute(routerConfig)

const DashboardRoutes = () => (
  <Suspense fallback={<Loading />}>
    <Switch>
      {routerMap.map(route => (
        <Route key={route.path} path={route.path} component={route.component} />
      ))}
      <Redirect to="/dashboard/index" />
    </Switch>
  </Suspense>
)

export default DashboardRoutes
